import { BaseEnum } from "./baseEnum";

const listEnum: Array<ExcusedAbsenceQualificationType> = [];

export class ExcusedAbsenceQualificationType extends BaseEnum {
  static LegalAbsence = new ExcusedAbsenceQualificationType(0, "LegalAbsence", "Ausência Legal");
  static PreAbono = new ExcusedAbsenceQualificationType(1, "PreAbono", "Pré-Abono");

  constructor(public id: number, public value: string, public label: string) {
    super(id, value, label);
    listEnum.push(this);
  }

  public static buildListEnum(): Array<BaseEnum> {
    return listEnum;
  }
}
